import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MAmzone } from '@argalis-apps/models';
import { CommunicationConfigService } from '../communication-config/communication-config.service';
@Injectable({
  providedIn: 'root'
})
export class UploadService {
  constructor(private http: HttpClient, private communicationConfigService: CommunicationConfigService) {}

  uploadFile(reqBody): Observable<MAmzone.IAmazoneUploadReponse> {
    const filesToUpload = new FormData();
    filesToUpload.append('files', reqBody);
    return this.http.post<MAmzone.IAmazoneUploadReponse>(
      `${this.communicationConfigService.getApiUri()}/upload`,
      filesToUpload
    );
  }
}
